import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=f7004bde&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7004bde')) {
      api.createRecord('f7004bde', component.options)
    } else {
      api.reload('f7004bde', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=f7004bde&", function () {
      api.rerender('f7004bde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4d195u9WS0g8j/JS/comp/childrenage.vue"
export default component.exports